// Frontend-only value set for the admin surface. See enums/shell.ts for the rationale.

export const GUIDELINES_CHOICES = ["default", "upload"] as const;
export type GuidelinesChoice = (typeof GUIDELINES_CHOICES)[number];
export const GUIDELINES_CHOICE = {
  DEFAULT: "default",
  UPLOAD: "upload",
} as const satisfies Record<string, GuidelinesChoice>;
